import {
  FetchSecuritySettingsRequest,
  FetchSecuritySettingsSuccess,
  FetchSecuritySettingsFailure,
  UpdateSecuritySettingsRequest,
  UpdateSecuritySettingsSuccess,
  UpdateSecuritySettingsFailure,
} from './security-settings.actions'
import { SecuritySettingsService } from './security-settings.service'
import { ShowSnackbar } from '../../shared/shared.actions'
import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import * as SecuritySettingsTypes from './security-settings.types'
import { map, switchMap, tap, catchError } from 'rxjs/operators'
import { Router } from '@angular/router'

@Injectable()
export class SecuritySettingsEffects {
  constructor(
    private actions: Actions,
    private securitySettingsService: SecuritySettingsService,
  ) {}

  FetchSecuritySettings$ = createEffect(() =>
    this.actions.pipe(
      ofType(SecuritySettingsTypes.FETCH_SECURITY_SETTINGS_REQUEST),
      switchMap((action: FetchSecuritySettingsRequest) => {
        return this.securitySettingsService.fetchSecuritySettings().pipe(
          map((result) => {
            return new FetchSecuritySettingsSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchSecuritySettingsFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  UpdateSecuritySettings$ = createEffect(() =>
    this.actions.pipe(
      ofType(SecuritySettingsTypes.UPDATE_SECURITY_SETTINGS_REQUEST),
      switchMap((action: UpdateSecuritySettingsRequest) => {
        return this.securitySettingsService
          .updateSecuritySettings(action.payload)
          .pipe(
            switchMap((result) => {
              return [new UpdateSecuritySettingsSuccess()]
            }),
            catchError((err, caught) => {
              return of(new UpdateSecuritySettingsFailure({ error: err }))
            }),
          )
      }),
    ),
  )
}
